import React from "react";
import {createUseStyles} from "react-jss";

type StyleProps = {
	width: number
	height: number
	top: number
	left: number
}

const useStyles = createUseStyles({
	partialCircle: {
		position: "absolute",
		top: props => props.top,
		left: props => props.left,
		width: props => props.width,
		height: props => props.height,
	}
});

type CircleLabelProps = {
	leftRadius:number
	rightRadius:number
	thickness: number
	color: string
	width: number
	top: number
	left: number
}

export default function CircleLabel({leftRadius, rightRadius, thickness, color, width, top, left}:CircleLabelProps) {
	const largerRadius = Math.max(leftRadius, rightRadius);
	const classes = useStyles({width, height: (largerRadius+thickness)*2, top, left});
	const commonArgs = {
		stroke:color,
		strokeWidth:thickness,
		fill:"none"
	};
	const halfThickness = thickness/2;
	const cy = largerRadius+halfThickness;

	return (
		<svg className={classes.partialCircle}>
			<circle cx={leftRadius+halfThickness} cy={cy} r={leftRadius} {...commonArgs}/>
			<line x1={leftRadius*2+thickness} y1={cy} x2={width-rightRadius*2} y2={cy} {...commonArgs}/>
			<circle cx={width-rightRadius-halfThickness} cy={cy} r={rightRadius} {...commonArgs}/>
		</svg>
	);
}